import environment from "./base";
const baseApi = "https://edify-api-dev.edify.la";
const env = environment(baseApi, baseApi);
const localConfig = {
  ...env,
  intervals: {
    ...env.intervals,
    logout: 600, 
  },
  isProduction: false,
  isDevelopment: true,
  env: "local",
  SENTRY_DSN: "",
  googleMaps: {
    apiKey: process.env.REACT_APP_GOOGLE_MAPS_API_KEY,
  },
  googleOAuth: {
    clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID,
  },
  mercadoPago: {
    publicKey: "TEST-29c2c6a6-8092-447a-8b33-803930bb6fa6",
    clientId: "8639587373625884", 
    redirectUri: "https://unsavoury-monandrous-sandy.ngrok-free.dev/documentacion-de-obra/oauth-callback",
  },
};

export default localConfig;
